import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { EditRounded, VisibilityOutlined } from "@mui/icons-material";
import { AdminToggle, DataTableColumn, StatusBadge } from "../../../components/ui";
import { VehiclesWithFilterNPaginationResponse } from "../../../services/vehicleService";

type Options = {
    onEdit: (vehicle: VehiclesWithFilterNPaginationResponse) => void;
    onView: (vehicle: VehiclesWithFilterNPaginationResponse) => void;
    onToggle: (vehicle: VehiclesWithFilterNPaginationResponse) => void;
};

/** Colunas da tabela de veículos (Nome / Mecanismo / Status / Ações). */
export function buildVehicleColumns({ onEdit, onView, onToggle }: Options): DataTableColumn<VehiclesWithFilterNPaginationResponse>[] {
    return [
        {
            key: "name",
            header: "Nome",
            width: "2fr",
            render: (row) => <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "text.primary" }}>{row.name}</Typography>,
        },
        {
            key: "mechanism_action",
            header: "Mecanismo",
            width: "3fr",
            render: (row) => (
                <Typography
                    sx={{ fontSize: "13px", color: "text.secondary", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                >
                    {row.mechanism_action}
                </Typography>
            ),
        },
        {
            key: "status",
            header: "Status",
            width: "120px",
            render: (row) => <StatusBadge status={row.enabled === 1 ? "Ativo" : "Inativo"} />,
        },
        {
            key: "actions",
            header: "Ações",
            width: "160px",
            align: "right",
            render: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5 }}>
                    <Tooltip title="Editar">
                        <IconButton
                            size="small"
                            aria-label="Editar"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(row);
                            }}
                            sx={{ borderRadius: "9px" }}
                        >
                            <EditRounded sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Visualizar">
                        <IconButton
                            size="small"
                            aria-label="Visualizar"
                            onClick={(e) => {
                                e.stopPropagation();
                                onView(row);
                            }}
                            sx={{ borderRadius: "9px" }}
                        >
                            <VisibilityOutlined sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Tooltip>
                    <AdminToggle checked={row.enabled === 1} onChange={() => onToggle(row)} />
                </Box>
            ),
        },
    ];
}
